const data = [
  {
    id: 1,
    playerName: "Siddhi",
    score: 0,
  },
  {
    id: 2,
    playerName: "Kriti",
    score: 0,
  },
  {
    id: 3,
    playerName: "Riya",
    score: 0,
  },
  {
    id: 4,
    playerName: "Khushi",
    score: 0,
  },
  {
    id: 5,
    playerName: "Krupali",
    score: 0,
  },
  {
    id: 6,
    rankingNumber: 6,
    playerName: "Sagar",
    score: 0,
  },
  {
    id: 7,
    playerName: "Yashvi",
    score: 0,
  },
  {
    id: 8,
    playerName: "Priya",
    score: 0,
  },
  {
    id: 9,
    playerName: "Ravi",
    score: 0,
    color: "green",
  },
  {
    id: 10,
    playerName: "Anjali",
    score: 0,
  },
  {
    id: 11,
    playerName: "Siddhi",
    score: 0,
  },
];

export default data;
